import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ContainerInput } from '@trackback/widgets';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { combineLatest } from 'rxjs';
import { ParserService } from '@app/services/parser.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'tb-container',
  imports: [DynamicWidgetDirective],
  template: `
    @for (child of input().children; track $index) {
      <ng-container [dynamicWidget]="child" [context]="context()" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'parsedClasses()',
  },
})
export default class ContainerComponent extends WidgetInputBaseComponent<ContainerInput> {
  _parser = inject(ParserService);
  input$ = toObservable(this.input);
  context$ = toObservable(this.context);
  parsedClasses = toSignal(
    combineLatest([this.input$, this.context$]).pipe(
      switchMap(([input, context]) =>
        this._parser.parse(input.styleClasses, { context })
      )
    )
  );
}
